import { render, staticRenderFns } from "./SwitchCourse.vue?vue&type=template&id=13d2b809&scoped=true"
import script from "./SwitchCourse.vue?vue&type=script&lang=js"
export * from "./SwitchCourse.vue?vue&type=script&lang=js"
import style0 from "./SwitchCourse.vue?vue&type=style&index=0&id=13d2b809&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2b809",
  null
  
)

export default component.exports